// import React, { useState } from 'react'
// import { useDispatch, useSelector } from 'react-redux';
// import { useNavigate } from 'react-router-dom';
// import { request } from '../utils/request';
// import { accidentAction } from '../redux/slices/accidentSlice';
// import { toast } from 'react-toastify';
// import {ClipLoader} from "react-spinners"
// function AddAdmin() {
//     const dispatch = useDispatch();
//     const navigate = useNavigate();
//       const [formData, setFormData] = useState({
//         username:'',
//         password: '',
//         email:'',
//       });
//       const {isloading} = useSelector(state => state.accident)
//     const handleSubmit = async (e) => {
//       e.preventDefault();
//       const data = new FormData();
//       Object.keys(formData).forEach(key => {
//           data.append(key, formData[key]);
//       });
//       try {
//         dispatch(accidentAction.setCreatePhotoLoading(true))
//         const response = await request.post('/auth/register_admin', data, {
//           headers: {
//             'Content-Type': 'multipart/form-data',
//           },
//         });
//         toast.success("Admin created successfully");
//         dispatch(accidentAction.setCreatePhotoLoading(false));
//         navigate("/partner");
//       } catch (error) {
//         dispatch(accidentAction.setCreatePhotoLoading(false));
        
//         // التحقق من وجود error.response أولاً
//         const errorMessage = error.response?.data?.message || "An error occurred";
//         toast.error(errorMessage);
        
//         console.error('Error creating user:', error);
//       }
//     };
//     const admin = JSON.parse(sessionStorage.getItem("user"));

//     console.log(admin);
    
//   return (
//     <div className='flex flex-col w-full h-screen overflow-y-auto hidden-scrollbar px-2 md:px-0'>
//       <div className="pl-2 md:pl-5 flex flex-col md:flex-row justify-between w-full pt-9 items-center ">
//         <div>
//           <h1 className="font-montserrat text-xl md:text-2xl font-bold">Neuen Partner erstellen</h1>
//         </div>
//         <div className="flex items-center mt-2 md:mt-0">
//           <div className="text-center md:text-right">
//             <h4 className="text-sm">{admin.username}</h4>
//             <p className="text-xs text-gray-600">{admin.role}</p>
//           </div>
//           <div className="w-10 h-10 md:w-12 md:h-12 rounded-full border border-gray-800 ml-2">
//             <img src={admin.profilePhoto?.url} alt="img-pro" className="w-full h-full rounded-full" />
//           </div>
//         </div>
//       </div>
//       <div className="border-b border-black w-full mt-3"></div>

//       <div className="bg-gray-100 p-4 md:p-8">
//         <h1 className="text-lg md:text-2xl font-bold mb-4">Füllen Sie bitte folgende Informationen</h1>
//         <form className="flex flex-col space-y-4">
//           <div className="flex flex-col md:flex-row md:items-center w-full">
//             <label className="font-bold w-full md:w-1/4 mb-1 md:mb-0">Benutzername</label>
//             <input
//               type="text"
//               name="username"
//               value={formData.username}
//               onChange={(e) => setFormData({ ...formData, username: e.target.value })}
//               className="w-full border border-gray-300 bg-[#c8e8ef] rounded-lg p-2 focus:outline-none"
//             />
//           </div>

//           <div className="flex flex-col md:flex-row md:items-center w-full">
//             <label className="font-bold w-full md:w-1/4 mb-1 md:mb-0">Passwort</label>
//             <input
//               type="text"
//               name="password"
//               value={formData.password}
//               onChange={(e) => setFormData({ ...formData, password: e.target.value })}
//               className="w-full border border-gray-300 bg-[#c8e8ef] rounded-lg p-2 focus:outline-none"
//             />
//           </div>


//           <div className="flex flex-col md:flex-row md:items-center w-full">
//             <label className="font-bold w-full md:w-1/4 mb-1 md:mb-0">Email</label>
//             <input
//               type="email"
//               name="email"
//               value={formData.email}
//               onChange={(e) => setFormData({ ...formData, email: e.target.value })}
//               className="w-full border border-gray-300 bg-[#c8e8ef] rounded-lg p-2 focus:outline-none"
//             />
//           </div>
//           <div className="flex justify-center pb-8">
//             <button 
//               onClick={handleSubmit} 
//               className="w-full md:w-40 bg-[rgb(255,222,89)] border border-black rounded-lg py-4 px-6 flex justify-center items-center " 
//               disabled={isloading}
//             >
//               {isloading ? (
//                 <ClipLoader size={20} color="#000" />
//               ) : (
//                 "Erstellen"
//               )}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   )
// }

// export default AddAdmin



import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { request } from '../utils/request';
import { accidentAction } from '../redux/slices/accidentSlice';
import { toast } from 'react-toastify';
import { ClipLoader } from "react-spinners";

function AddAdmin() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    email: '',
  });
  const { isloading } = useSelector(state => state.accident);

  // جلب بيانات المستخدم الحالي
  const admin = JSON.parse(sessionStorage.getItem("user"));

  const handleSubmit = async (e) => {
    e.preventDefault();

    // التحقق من الحقول الإلزامية
    if (!formData.username || !formData.password || !formData.email) {
      toast.error("Please fill in all required fields");
      return;
    }

    try {
      dispatch(accidentAction.setCreatePhotoLoading(true));
      const response = await request.post('/auth/register_admin', formData, {
        headers: {
          'Content-Type': 'application/json', // أرسل البيانات كـ JSON
        },
      });
      toast.success("Admin created successfully");
      dispatch(accidentAction.setCreatePhotoLoading(false));
      navigate("/Admin"); // يمكنك تغيير هذا إلى المسار الذي تريد التوجيه إليه بعد الإنشاء
    } catch (error) {
      dispatch(accidentAction.setCreatePhotoLoading(false));
      const errorMessage = error.response?.data?.message || "An error occurred";
      toast.error(errorMessage);
      console.error('Error creating admin:', error);
    }
  };

  return (
    <div className='flex flex-col w-full h-screen overflow-y-auto hidden-scrollbar px-2 md:px-0'>
      <div className="pl-2 md:pl-5 flex flex-col md:flex-row justify-between w-full pt-9 items-center ">
        <div>
          <h1 className="font-montserrat text-xl md:text-2xl font-bold">Neuen Admin erstellen</h1>
        </div>
        <div className="flex items-center mt-2 md:mt-0">
          <div className="text-center md:text-right">
            <h4 className="text-sm">{admin.username}</h4>
            <p className="text-xs text-gray-600">{admin.role}</p>
          </div>
          <div className="w-10 h-10 md:w-12 md:h-12 rounded-full border border-gray-800 ml-2">
            <img src={admin.profilePhoto?.url} alt="img-pro" className="w-full h-full rounded-full" />
          </div>
        </div>
      </div>
      <div className="border-b border-black w-full mt-3"></div>

      <div className="bg-gray-100 p-4 md:p-8">
        <h1 className="text-lg md:text-2xl font-bold mb-4">Füllen Sie bitte folgende Informationen</h1>
        <form className="flex flex-col space-y-4">
          <div className="flex flex-col md:flex-row md:items-center w-full">
            <label className="font-bold w-full md:w-1/4 mb-1 md:mb-0">Benutzername</label>
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={(e) => setFormData({ ...formData, username: e.target.value })}
              className="w-full border border-gray-300 bg-[#c8e8ef] rounded-lg p-2 focus:outline-none"
              required
            />
          </div>

          <div className="flex flex-col md:flex-row md:items-center w-full">
            <label className="font-bold w-full md:w-1/4 mb-1 md:mb-0">Passwort</label>
            <input
              type="password" // استخدم type="password" لإخفاء النص
              name="password"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              className="w-full border border-gray-300 bg-[#c8e8ef] rounded-lg p-2 focus:outline-none"
              required
            />
          </div>

          <div className="flex flex-col md:flex-row md:items-center w-full">
            <label className="font-bold w-full md:w-1/4 mb-1 md:mb-0">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              className="w-full border border-gray-300 bg-[#c8e8ef] rounded-lg p-2 focus:outline-none"
              required
            />
          </div>

          <div className="flex justify-center pb-8">
            <button 
              onClick={handleSubmit} 
              className="w-full md:w-40 bg-[rgb(255,222,89)] border border-black rounded-lg py-4 px-6 flex justify-center items-center " 
              disabled={isloading}
            >
              {isloading ? (
                <ClipLoader size={20} color="#000" />
              ) : (
                "Erstellen"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddAdmin;